import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Footer.css";
import { Link } from "react-router-dom";
// Import images
import arrowImg from "../../asset/arrow.png";
import emailImg from "../../asset/email.png";
import phoneImg from "../../asset/phone.png";
import addressImg from "../../asset/address.png";
import linkindImg from "../../asset/linkind.png";
import facebookImg from "../../asset/facebook.png";
import instagramImg from "../../asset/instagram.png";

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row>
          {/* Quick Links */}
          <Col md={4} sm={12} className="mb-2">
            <h5 className="footer-title underline">QUICK LINKS</h5>
            <ul className="footer-links">
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><a href="https://incometaxindia.gov.in/Pages/default.aspx">INCOME TAX</a></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><a href="https://rof.mahaonline.gov.in/">REGISTER OF FIRMS</a></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><a href="https://www.gst.gov.in/">GST</a></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><a href="https://ewaybillgst.gov.in/">E-WAY BILL</a></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><a href="https://www.icai.org/">ICAI</a></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><a href="https://mahagst.gov.in/en">MAHA GST</a></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><a href="https://contents.tdscpc.gov.in/">TRACES</a></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><a href="https://www.cagmc.com/iso-certification.php">ISO CERTIFICATION</a></li>
            </ul>
          </Col>

          {/* Services */}
          <Col md={4} sm={12} className="mb-4">
            <h5 className="service-footer-title underline">SERVICES</h5>
            <ul className="footer-links">
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /> <Link to="/services/accounting">ACCOUNTING</Link></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><Link to="/services/consulting">MANAGEMENT CONSULTANCY SERVICES</Link></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><Link to="/services/tds">TDS</Link></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><Link to="/services/indirect-taxation">INDIRECT TAXATION</Link></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><Link to="/services/audit-assurance">AUDIT & ASSURANCE</Link></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><Link to="/services/corporate-governance">CORPORATE GOVERNANCE & SECRETARIAL PRACTICE</Link></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><Link to="/services/business-startup">BUSINESS START-UP & SUPPORT</Link></li>
              <li><img src={arrowImg} alt="arrow" className="arrow-icon" /><Link to="/services/professional-governance">OTHER PROFESSIONAL SERVICES</Link></li>
            </ul>
          </Col>

          {/* Contact Us + Social */}
          <Col md={4} sm={12}>
            <h5 className="contact-footer-title underline">CONTACT US</h5>
            <ul className="footer-contact">
              <li><img src={addressImg} alt="address" className="contact-icon" /><span>06, LANDSCAPE APARTMENT, B/H AMOL PUSTAKALAY, NEAR IDFC BANK, SHAHID CIRCLE, GANGAPUR ROAD, NASHIK - 422005</span></li>
              <li><img src={phoneImg} alt="phone" className="contact-icon" /><span>+91 8080098225 / +91 7875529088</span></li>
              <li><img src={emailImg} alt="email" className="contact-icon" /><span>casudarshanandcompany@gmail.com</span></li>
            </ul>

            {/* Social Section */}
           {/* Social Section */}
{/* Social Section */}
<div className="social-section mt-3">
  <h5 className="touch-footer-title no-underline">GET IN TOUCH</h5>
  <div className="footer-social-icons mt-2">
    <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
      <img src={linkindImg} alt="LinkedIn" className="social-icon" />
    </a>
    <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
      <img src={facebookImg} alt="Facebook" className="social-icon" />
    </a>
    <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
      <img src={instagramImg} alt="Instagram" className="social-icon" />
    </a>
  </div>
</div>


          </Col>
        </Row>

        {/* Bottom Row */}
        <Row>
          <Col className="text-center mt-2 mb-3">
            <p className="footer-bottom">
              © {new Date().getFullYear()} Created by CA Sudarshan V. Kalunge & Co. |{" "}
              <a
                href="https://nexonica.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#fff", textDecoration: "none" }}
              >
                Developed by Nexonica Systems Pvt. Ltd.
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
